import { useQuery } from "@tanstack/react-query";

import { quoteRequestLineOverthicknessQuery } from "#modules/quoteRequestLines/infra/quoteRequestLineOverthickness.query";

export const useQuoteRequestLineOverthickness = (quoteRequestLineId: string | undefined) => {
  const { data, ...rest } = useQuery(quoteRequestLineOverthicknessQuery(quoteRequestLineId));
  return { overthickness: data || null, ...rest };
};
